import { BasicDialogProperties } from "../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2ReportPlayerDialogProperties extends BasicDialogProperties {
    public reportPlayerUserId: number = 0;
    public reportPlayerName: string;
    constructor(reportPlayerUserId: number, reportPlayerName: string) {
        super();

        this.reportPlayerUserId = reportPlayerUserId;
        this.reportPlayerName = reportPlayerName;
    }
}
